/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability for a widget to specify the directions in which the MnemonicsManager is allowed to navigate when
 * the focus is on the widget. For example, a TextField would want to allow only vertical navigation and not horizontal,
 * since left/right keys should act on moving the cursor within the TextField and not the focus to the adjacent widgets.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * This only requires the focusNode of the Widget.
 *
 * @module MW/toolstrip/mixins/property/MnemonicKeyNavDirectionMixin
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare",
    "MW/toolstrip/constants/TypeConstants"
], function (declare, TypeConstants) {

    var SUPPORTED_VALUES = ["all", "none", "horizontal", "vertical"];

    return declare(null, {

        /**
         * @property  {string} mnemonicKeyNavDirection
         * @instance
         */
        mnemonicKeyNavDirection: "all",

        postCreate: function () {
            this.inherited(arguments);
            this._updateMnemonicKeyNavDirectionInDOM(this.get("mnemonicKeyNavDirection"));
        },

        _setMnemonicKeyNavDirectionAttr: function (mnemonicKeyNavDirection) {
            if (SUPPORTED_VALUES.indexOf(mnemonicKeyNavDirection) === -1) {
                throw new Error("'mnemonicKeyNavDirection' property expects one of these values: " + SUPPORTED_VALUES);
            }

            if (this._started) {
                this._updateMnemonicKeyNavDirectionInDOM(mnemonicKeyNavDirection);
            }

            this._set("mnemonicKeyNavDirection", mnemonicKeyNavDirection);
        },

        _updateMnemonicKeyNavDirectionInDOM: function (mnemonicKeyNavDirection) {
            this.focusNode.setAttribute("data-mnemonic-key-nav-direction", mnemonicKeyNavDirection);

            // Set the "data-mnemonic-key-nav-direction" attribute for nodes other than focusNode
            if (this.mnemonicKeyNavDirectionNodes && this.mnemonicKeyNavDirectionNodes.length > 0) {
                this.mnemonicKeyNavDirectionNodes.forEach(function(node) {
                    node.setAttribute("data-mnemonic-key-nav-direction", mnemonicKeyNavDirection);
                });
            }
        }
    });

});